import { gql } from '@apollo/client'

export default gql(`
query getUserAdminAttributes( $id: String! ) {
    getUserAdminAttributes( 
      id: $id
    ) {
        adminAttributes{
           key
           value
           title
        }
    }
}`)
